'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';
import { Popover } from '../popover/popover.js';

/**
 * Dropdown component, used to display a list of options.
 *
 * @example with TriggerContext
 * <Dropdown.TriggerContext>
 *   <Dropdown.Trigger>Dropdown trigger</Dropdown.Trigger>
 *   <Dropdown placement='bottom-end'>
 *     <Dropdown.Heading>Dropdown</Dropdown.Heading>
 *     <Dropdown.List>
 *       <Dropdown.Item>
 *         <Dropdown.Button>Option</Dropdown.Button>
 *       </Dropdown.Item>
 *     </Dropdown.List>
 *   </Dropdown>
 * </Dropdown.TriggerContext>
 *
 * @example without TriggerContext
 * <Button popovertarget="my-dropdown">Trigger</Button>
 * <Dropdown id="my-dropdown">
 *   <Dropdown.Heading>Heading</Dropdown.Heading>
 *   <Dropdown.List>
 *     <Dropdown.Item>
 *       <Dropdown.Button>Item</Dropdown.Button>
 *     </Dropdown.Item>
 *   </Dropdown.List>
 * </Dropdown>
 */
const Dropdown = forwardRef(function DropdownContent({ placement = 'bottom-end', className, ...rest }, ref) {
    return (jsx(Popover, { className: cl('ds-dropdown', className), placement: placement, ref: ref, ...rest }));
});

export { Dropdown };
